import React, { useEffect, useState } from "react";
import { Box, Select, Spinner, Text, useToast } from "@chakra-ui/react";
import { getProductByCode } from "./services/MrcaiAPI";

const ProductSignalSelect = ({
  label = "Select Signal",
  productCode,
  selectedSignal,   // ✅ correct prop name
  onChange,
  size = "md",
  height,
}) => {
  const toast = useToast();
  const [product, setProduct] = useState(null);
  const [productLoaded, setProductLoaded] = useState(false);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        setProduct(await getProductByCode(productCode));
      } catch (err) {
        toast({ title: "Failed to load product", description: err.message, status: "error" });
      } finally {
        setProductLoaded(true);
      }
    };
    fetchProduct();
  }, [productCode, toast]);

  return (
    <Box>
      {label && <Text mb={2}>{label}</Text>}
      {!productLoaded ? (
        <Spinner size={size} />
      ) : product?.signalRegister?.length ? (
<Select
  placeholder="Select signal..."
  value={selectedSignal?.type ?? ""}              // ✅ matches option values
  onChange={(e) => {
    const sig = product.signalRegister.find(s => s.type === e.target.value);
    onChange(sig || null);
  }}
  size={size}
  height={height}
>
  {product.signalRegister.map((signal) => (
    <option key={String(signal.type)} value={String(signal.type)}>
      {signal.name}
    </option>
  ))}
</Select>
      ) : (
        <Text color="red.500">No signals found.</Text>
      )}
    </Box>
  );
};

export default ProductSignalSelect;
